import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateAssetHistoryController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
function CreateSupplierContact({ modalInstance, currentAssetHistory, onClose, onSuccess, AssetID }) {

    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };
    const [formData, setFormData] = useState({ AssetID: AssetID, dt_Created: getCurrentDate(), vc_Description: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (currentAssetHistory) {
            const formattedDate = new Date(currentAssetHistory.dt_Created).toISOString().split('T')[0];
            setFormData({
                AssetID: AssetID, dt_Created: formattedDate, vc_Description: currentAssetHistory.vc_Description
            });
        } else {
            setFormData({
                AssetID: AssetID, dt_Created: getCurrentDate(), vc_Description: ''
            }); // Clear form data when switching to add mode
        }
    }, [currentAssetHistory]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission

        if (currentAssetHistory) {
            formData.PK_AssetHistory = currentAssetHistory.PK_AssetHistory;
        } else {
            formData.PK_AssetHistory = 0;
        }

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess(); // Call onSuccess to reload data
        }, () => {
            onSuccess(); // Call onSuccess to reload data
        });
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade AssetHistoryModal show d-block" id="AssetHistoryModal" tabIndex="-1" aria-labelledby="AssetHistoryModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{currentAssetHistory ? "Edit History" : "Add History"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                
                                <div className="modal-body">
                                    <div className="row mb-3" style={{ marginRight: "10px" }}>
                                    <table style={{ width: "100%" }}>
                                        <tbody>


                                            <tr>
                                                <td style={{width:"13%"}}> <label htmlFor="dt_Created" style={{float:"right"}}>Created <span style={{ "color": "red" }}>*</span></label></td>
                                                <td style={{width:"37%"}}>
                                                    <input type="date" className="form-control" name="dt_Created" value={formData.dt_Created} onChange={handleFieldChange} />
                                                    {errors.dt_Created && <div style={{ color: 'red' }}>{errors.dt_Created}</div>}
                                                </td>
                                                <td style={{width:"13%"}}></td>
                                                <td></td>

                                            </tr>
                                            <tr>
                                                <td>
                                                    <label htmlFor="vc_Description" style={{float:"right"}}>Description <span style={{ "color": "red" }}>*</span></label>
                                                </td>
                                                <td colSpan={3}>
                                                    <input type="text" className="form-control" name="vc_Description" value={formData.vc_Description} onChange={handleFieldChange} />
                                                    {errors.vc_Description && <div style={{ color: 'red' }}>{errors.vc_Description}</div>}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                       <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />    {currentAssetHistory ? " Update" : " Save"}
                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                       <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>
        </div>
    );
}
export default CreateSupplierContact;